import { P } from '@slal/ui/typography';
import { MaxWidthContent, BackButton } from '~/components';
import { useApplication, useApplicationSessionBack } from '~/hooks';
import { InvestmentOptionsWrapper } from './styles';
import { NavigationCard } from '~/components';
import { ApplicationFormKeys } from '~/types';
import { StyledApplicationButtonsWrapper } from '../styles';

export const INVESTMENT_PATHWAY_OPTIONS_PATH = '/application/investment-pathway-options';
export const FUND_OPTIONS_PATH = '/application/fund-options';

export const InvestmentOptionsForm = () => {
    const backRoute = useApplicationSessionBack('investment-options');
    const { setSession } = useApplication();

    const handleOptionClick = (optionType: string) => {
        const sessionData = {
            [ApplicationFormKeys.INVESTMENT_OPTIONS]: { option: optionType },
        };
        setSession(sessionData);
    };

    return (
        <MaxWidthContent>
            <P>You can switch investments any time, free of charge.</P>
            <InvestmentOptionsWrapper>
                <NavigationCard
                    to={INVESTMENT_PATHWAY_OPTIONS_PATH}
                    heading="Choose a ready made option"
                    onClick={() => handleOptionClick('default')}
                >
                    <P>Choose 1 of 4 ready made investment pathways that reflects your plans for the next 5 years.</P>
                </NavigationCard>
                <NavigationCard
                    to={FUND_OPTIONS_PATH}
                    heading="Choose your own investments"
                    onClick={() => handleOptionClick('custom')}
                >
                    <P>Choose from over 300 investment options.</P>
                </NavigationCard>
            </InvestmentOptionsWrapper>
            <StyledApplicationButtonsWrapper>
                <BackButton route={backRoute} />
            </StyledApplicationButtonsWrapper>
        </MaxWidthContent>
    );
};
